define('models/CustomerModel',['underscore', 'backbone', 'jquery', 'ObjectModel', 'LocalStorage', 'app',
        'hooks',
        'ApiRequest',
        'models/CustomerLikeCollection',
        'models/AdvantageGroupCollection',
        'models/AdvantageCollection',
        'models/OrderCollection',
        'models/OrderModel',
        'models/EstimatedTimeModel',
        'formatPrice',
        'phoneUtils',
        'moment',
        'momentFormats',
        'prototypes/ReCaptcha',

    ],
    function (_, Backbone, $, ObjectModel, LocalStorage, app,
              hooks,
              ApiRequest,
              CustomerLikeCollection,
              AdvantageGroupCollection,
              AdvantageCollection,
              OrderCollection,
              OrderModel,
              EstimatedTimeModel,
              formatPrice,
              phoneUtils,
              moment,
              momentFormats,
              ReCaptcha
)
{
    //
    // Model Customer
    //

    var hobbiesSlugs = ['art', 'musique', 'shopping', 'cinema', 'series', 'sport'],
        hobbiesNames =  ['Art','Musique','Shopping','Cinéma','Séries','Sport'];
        //hobbiesPolygons =  ['1','2','3','1','2','3'];

    var statusList = ['Ichi','Ni','San'];

    var orderCollection;

    function UndefinedValueTranslation() {
        return app.t("Non renseigné","Account");
    }

    function WrapReCaptcha(action){
        var deferred = $.Deferred();
        ReCaptcha(action, function(token) {
            deferred.resolve(token);
        }, function () {
            var message = app.t('Une erreur est survenue, liée à ReCaptcha, vérifiez peut-être votre logiciel antipub.','Account');
            app.banNotice(message);
            app.error('ReCaptchaError');
            deferred.reject();
        })
        return deferred;
    }

    //
    var CustomerModelPrototype = {

        name: 'CustomerModel',
        route: 'apiCustomerModel',
        idAttribute: 'id_customer',
        translated:false,
        privateApi:true,
        initialize: function ()
        {
            var customer = this;
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(customer, arguments);

            customer.on("change", customer.onChange);
            customer.on("change:orders", customer.onChangeOrder);
            customer.on("change:id_customer", customer.customerChange);
            customer.on("change:advantageGroups", customer.onChangeAdvantageGroups);
            customer.listenTo(app, "applyLogout", customer.logout);

        },

        ApiRequest:function(type,data,urlOptions,options){
            return this.pipeAppHttpHeaders(ApiRequest(type,data,urlOptions,options));
        },

        getDiscount:function()
        {
            return this.get('discounts');
        },

        loadAllOrders: function () {
            var model=this,
                ordersFull = new OrderCollection();
            function onSync() {
                model.ordersFull = ordersFull;
                app.trigger('allOrderLoad');
            }
            ordersFull.once('sync', onSync);
            ordersFull.remoteFetch();
            return ordersFull;
        },
        getAllOrders: function () {
            var model=this;
            return model.ordersFull;
        },
        getLastReorderOrders: function() {
            var reorders = this.getReorders(),
                selectedOrders = 0,
                orders =  [];

            if (reorders.length <= 0) {
                return _([])
            }
            var i = 0;
            while (selectedOrders < 3 && i < reorders.length) {
                var order = reorders[i]
                if (order && !order.isDesk()) {
                    orders.push(order)
                    selectedOrders++
                }
                i++;
            }
            return _(orders)
        },
        getCustomerGroup:function()
        {
            var customer= this;
            if (customer.isLogged())
            {
                return  customer.get('groups');
            }else
            {
                return ["1"]; // GUEST GROUP
            }
        },
        displayCagnotteAmount : function() {
            var amount = this.getCagnotteAmount(),
                formated = formatPrice(amount); // default formatting
            hooks.execHook('formatCagnotte',amount,function(f){
                formated = f;
            });
            return formated;
        },
        getCagnotteConversionRate : function() {
            var rate = 1; // default rate
            hooks.execHook('getCagnotteConversionRate',this,function(r){
                rate = r;
            });
            return rate;
        },
        getCagnotteAmount : function() {
            var amount = Math.floor(parseFloat(this.get('customer_loyalty_cagnotte')) * 100) / 100;
            if (!(amount>0)) {
                amount = 0;
            }
            return amount;
        },
        getComeinExpirationDate : function() {
            var date_exp = this.getNeolaneParam('amountExpirationDate');
            var date_exp_obj =  new Date(date_exp);
            return  date_exp_obj.getDate() + "-" +  date_exp_obj.getMonth() +"-" +  date_exp_obj.getFullYear() ;
        },
        //
        // Advantages
        //
        getAdvantageGroups:function(reset){
            var model = this,
                // advantageGroups
                advantageGroupsAttributeName = 'advantageGroups',
                // advantageGroupsCollection
                advantageGroupsCollectionAttributeName = advantageGroupsAttributeName+'Collection',
                //
                advantageGroupCollection = model.get(advantageGroupsCollectionAttributeName);
            //
            // prevent multiple instantiations of Collection and SubCollection
            //
            function getAdvantageGroupsDatas(){
                var rawDatas = model.get(advantageGroupsAttributeName);
                return rawDatas;
            }
            if(!advantageGroupCollection){
                advantageGroupCollection = new AdvantageGroupCollection(getAdvantageGroupsDatas());
                model.set(advantageGroupsCollectionAttributeName,advantageGroupCollection);
            }else if(reset){
                advantageGroupCollection.reset(getAdvantageGroupsDatas());
            }
            return advantageGroupCollection;
        },
        getUsableAdvantages:function(reset,onCart){
            // return usable Advantage Collection
            var model = this,
                usableAdvantagesAttributeName = 'usableAdvantages'+(onCart?'OnCart':''),
                advantages = model.get(usableAdvantagesAttributeName);
            if(!advantages || reset){
                var groups = model.getAdvantageGroups(reset), noReinstance = reset && advantages;
                if(noReinstance){
                    advantages.reset();
                }else{
                    advantages = new AdvantageCollection();
                }
                groups.each(function(group){
                    group.getUsableAdvantages(onCart).each(function(advantage){
                        advantages.add(advantage);
                    });
                });
                model.set(usableAdvantagesAttributeName,advantages);
                if(noReinstance) model.trigger('change:'+usableAdvantagesAttributeName,model);
            }
            return advantages;
        },
        onChangeAdvantageGroups:function(){
            // force reset of both usableAdvantagesCollection and advantageGroupsCollection
            // with updated values
            this.getUsableAdvantages(true,true);
        },
        //
        getTaxIdentficationNumber:function () {

            if ( app.c('_CUSTOMER_ENABLE_TAX_IDENTIFICATION_NUMBER_', 0) == 1) {
                var tax_identification_number = this.get('tax_indentification_number');
                return tax_identification_number;
            }
            return 0;

        },
        displayTaxIdentficationNumber:function(){
            var TIN = this.getTaxIdentficationNumber();
            switch(TIN){
                case 0: case '':
                    return UndefinedValueTranslation();
                default:
                    return TIN;
            }
        },
        formatBirthday:function(format){
            var birthday = this.get('birthday');
            format = format || 'LL';
            if (!birthday) {
                birthday = '';
            }
            var m = moment(birthday,'YYYY-MM-DD');
            return m.isValid() ? m.format(format) : '';

        },
        getAddresses:function(){
            return app.getAddresses();
        },
        getPrimaryAddress:function()
        {
            return app.getAddress(this.get('id_address_primary'));
        },
        displayPrimaryAddressData:function(){
            var address = this.getPrimaryAddress();
            return address ? address.getData() : '';
        },
        displayPrimaryAddress:function(){
            var address = this.getPrimaryAddress();
            return address ? address.formatAliasLabel() : UndefinedValueTranslation();
        },
        getPhone:function ()
        {
            var phone = this.get('phone');
            return phone;
        },
        displayPhone:function(){
            var phone = this.getPhone();
            if(phone && phone.length){
                phone = phoneUtils.formatNational(phone);
            }
            return phone ? phone : UndefinedValueTranslation();
        },
        getPhoneOrder:function() {
            var phoneOrder = this.get('phoneOrder');
            var phone = this.get('phone');
            if (!_.isUndefined(phone)) {
                return phone;
            }
            if (_.isUndefined(phoneOrder) || phoneOrder.length < 1) {
                return '';
            } else
            return phoneOrder[0];
        },
        getOrders:function(){
            var customer = this,
                orders = customer.get('orders');
            if (_.isUndefined(orders)){
                orders = [];
            }

            if(!orderCollection) {
                orderCollection = new OrderCollection(orders);
            }

            return orderCollection;
        },
        getOrder: function (id_order)
        {
            var orders = this.getOrders();
            return orders.findWhere({id_order: id_order.toString()});
        },
        getReorders:function(){
            var orders = this.getOrders();
            return orders.filterReorder();
        },
        getLastOrder:function(){
            var model = this,
                lastOrder = model.getOrders().getLastOrder(),
                lastOrdering = model.getOrdering().getLastOrder();
                if(lastOrdering){
                    if(lastOrder){
                        lastOrder = lastOrder.id < lastOrdering.id ? lastOrdering : lastOrder;
                    }else{
                        lastOrder = lastOrdering;
                    }
                }
            return lastOrder;
        },
        getOrdering: function ()
        {
            var model = this;
            var orders = model.get('ordering');

            if (_.isUndefined(orders)) orders = [];

            var collection = new OrderCollection(orders);
            return collection;

        },
        resetPassword:function(options) {
            return this.ApiRequest('CustomersetResetPassword', options)
                .done(function (result){
                    app.banNotice(result.message);
                }).fail(function (data, status){
                    var responseJSON = data.responseJSON;
                    if(responseJSON && responseJSON.error){
                        app.banNotice(responseJSON.error);
                    }else{
                        app.alert();
                    }
                });
        },
        setSmSAlert:function () {
            var model = this;
            model.ApiRequest('CustomersetSmsAlert')
                .done(function(result){
                    model.set(_(result).pick(['sms']));
                }).fail(function(){
                    app.alert();
                })
        },
        sponsorshipSendByEmail:function(emailList)
        {
            return this.ApiRequest('CustomerSponsorshipSendByEmail', {emailList: emailList})
        },
        getSponsorship:function()
        {
            var sponsorships = this.get('sponsorship');
            if (_.isUndefined(sponsorships)) sponsorships = false;
            return sponsorships;
        },
        setNewsletter:function () {
            var model = this;

            model.ApiRequest('CustomersetNewsletter')
                .done(function(result){
                    model.set(_(result).pick(['mail_alert']));
                }).fail(function(){
                    app.alert();
                })
        },
        getChildren: function()
        {
          return parseInt(this.get('children'));
        },
        displayChildren:function(){
            var children = this.getChildren();
            return children >=0 ? parseInt(children) : UndefinedValueTranslation();
        },
        getMaritalStatus: function()
        {
          var maritalStatus = this.get('marital_status');
            return maritalStatus;
        },
        isProspect:function(){
            // est-ce que l'utilisateur est un nouveau client
            return this.getOrders().size() < 2;
        },
        getCards: function (filterBrandIds)
        {
            var cards = this.get('card');
            if (_.isUndefined(cards)) cards = [];

            if(filterBrandIds){
                cards = _(cards).filter(function(card){
                    return _(filterBrandIds).contains(card.brand);
                });
            }

            cards.sort(function(a,b){
               return a.id_card < b.id_card ? 1 : -1;
            });


            cards.sort(function(a,b){
                return a.brand < b.brand ? -1 : 1;
            });

            return _(cards);
        },
        getCard:function(id_card){
            var cards = this.getCards();
            return cards.findWhere({id_card:id_card})
        },
        addPaymentCard:function(card){
            var model = this,
                cards = model.get('card');
            cards.push(card);
            model.trigger('addCard',model);
        },
        // current customer key is not based on id_customer
        getLocalStorageKey: function ()
        {
            return this.name + '_' + app.getCountryCode();
        },
        onChange: function ()
        {
            //
            this.updateLocalStorageItem(); // met à jour localStorage
        },
        onChangeOrder:function(){
            orderCollection = false;
        },
        customerChange: function (customer, b, c)
        {
            this.onChangeOrder();
            this.trigger(customer.isLogged() ? 'login' : 'logout', customer);
        },
        likeProduct: function (id_product)
        {
            var model = this;
            model.ApiRequest('CustomerLikeProduct', {
                id_product: id_product,
            }).done(function (result) {
                model.set(_(result).pick(['likes']));
                app.trigger('FavoritesChange');
            }).fail(function(){
                app.alert();
            });
        },
        displayMaritalStatus:function()
        {
            var label = '';
            switch(this.getMaritalStatus().toString() )
            {
                case '1':
                    label = t('Célibataire','Account');
                    break;
                case '2':
                    label = t('En couple','Account');
                    break;
                case '3':
                    label = t('Marié(e)','Account');
                    break;
                case '4':
                    label = t('Autre','UI');
                default :
                    label = UndefinedValueTranslation();
                    break;
            }
            return label;
        },

        // retourne si un produit est liké
        isProductLiked: function (id_product)
        {
            return _(this.get('likes')).contains(id_product);
        },
        isLogged: function ()
        {
            return !_.isUndefined(this.get('id_customer')) && (this.get('id_customer') != '');
        },
        requireRgpdType: function ()
        {
            // les utilisateur non connecté sont valides
            var model = this, requireOptin = 1, requireFields = 0,
                logged = model.isLogged() ? 1 : 0;
            if(logged){
                requireOptin = (app.isRGPD() && !model.get('optin')) ? 1 : 0;
                _(['id_gender','lastname','firstname','phone','birthday']).each(function(key){
                    var value = model.get(key);
                    if(!!requireFields || !value || (key==='birthday' && value==='0000-00-00')){
                        requireFields = 1;
                    }
                });
            }
            // 0 : non connecté ou tout est OK
            // 1 : optin requis
            // 2 : champs requis
            // 3 : optin et champs requis
            return logged * (requireOptin + 2 * requireFields);
        },
        requireOptin:function(){
           return this.requireRgpdType() % 2 === 1;
        },
        requireFields:function(){
           return this.requireRgpdType() > 1;
        },
        requireRgpdOptin:function(){
            return this.requireRgpdType() > 0;
        },
        getStore:function(){
            return app.getStore(this.get('shopLike'));
        },
        getSegment:function () {
            return this.get('segmentation');
        },
        getSegmentName:function(){
            return statusList[parseInt(this.getSegment())-1] || '';
        },
        isComein: function(){
            return this.get('comein') == true;
        },
        isComeinSegmentation: function(segmentation){
            // TODO
            var customer_segmentation = this.getSegment();
            if (customer_segmentation)
            {
                customer_segmentation = customer_segmentation.toString();
            }
            return this.isComein() && (segmentation.indexOf(customer_segmentation) != -1);
        },
        getIdComein:function(){
            return this.get('id_customer_comin')
        },
        getIdNeolane:function(){
            return this.getNeolaneParam('id_customer_neolane', '');
        },
        removeCard:function (id_card)
        {
	        var customer = this;
            return customer.ApiRequest('CustomerRemoveCard', {
                id_card:id_card,
            })
                .done(function (data, status)
                {
	                customer.set(_(data).pick(['card']));
                })
                .fail(function (data, status)
                {
                    if(data.responseJSON && data.responseJSON.error){
                        app.banNotice(data.responseJSON.error);
                    }else{
                        app.alert();
                    }
                });
        },
        // factorisation des requetes de connexion (basic, facebook, google)
        requestLogin: function (apiRoute, options)
        {
            var customer = this, recaptchaAction = 'signin';
            if(apiRoute === 'LoginFacebook' || apiRoute === 'LoginGoogle' ){
                options.is_webmobile = app.isMobile() ? 1:0;
                recaptchaAction = 'social_connect';
            }
            return WrapReCaptcha(recaptchaAction).done(function(recaptcha_token){
                options.token = recaptcha_token; // recaptcha_token
                customer.ApiRequest(apiRoute, options)
                .done(function (data, status){
                    var cart = app.getCart(),
                        requireRGPD = data.requireRGPD;
                    // validation RGPD
                    if (requireRGPD && requireRGPD == true)
                    {
                        app.confirm(app.c("_RGPD_POPIN_CONNEXT_TEXT_"), function(state){
                          if(state){
                              options.validateByCustomerRGP = true;
                              customer.requestLogin(apiRoute, options );
                          }
                        });
                        return;
                    }
                    customer.trigger('loginSuccess',customer,apiRoute);
                    cart.remoteFetch();
                    customer.remoteFetch();
                })
                .fail(function (data, status){
                    var responseJSON = data.responseJSON, message, error = status;
                    if(responseJSON && responseJSON.error){
                        if(responseJSON.message){
                            message = responseJSON.message;
                        }else{
                            message = responseJSON.error;
                        }
                        error = responseJSON.error;
                    }
                    customer.trigger('loginFail', customer, error, message, data);
                    if(error === 'invalid_captcha'){
                        app.alertReCaptcha(message);
                    }else if(message) {
                        app.banNotice(message);
                    }else{
                        app.alert();
                    }
                });
            })
        },
        // basic login
        login: function (datas)
        {
            return this.requestLogin('Login', _.pick(datas, 'email', 'password', 'password_v2', 'password_v2_confirmation'));
        },
        // facebook login
        loginFacebook: function ()
        {
            return this.requestLogin('LoginFacebook', {});
        },
        // google login
        loginGoogle: function (id_token)
        {
            return this.requestLogin('LoginGoogle', {id_token: id_token});
        },


        registerNewsletter: function (registerParameters)
        {
            return this.ApiRequest('RegisterNewsLetter', registerParameters)
                .done(function (data, status)
                {
                    app.banNotice(data.message);
                })
                .fail(function (data, status)
                {
                    if(data.responseJSON && data.responseJSON.error){
                        app.banNotice(data.responseJSON.error);
                    }else{
                        app.alert();
                    }
                });
        },

        register: function (registerParameters)
        {
            var customer = this;
            registerParameters.is_webmobile = app.isMobile() ? 1:0;

            return WrapReCaptcha('signup').done(function(recaptcha_token){
              registerParameters.token = recaptcha_token;
              customer.ApiRequest('Register', registerParameters)
                .done(function (data, status)
                {
                    customer.trigger('registerSuccess', customer);
                    customer.remoteFetch();
                })
                .fail(function (data, status)
                {
                    customer.trigger('registerFail', customer, data);
                    if(data.responseJSON && data.responseJSON.error){
                        app.banNotice(data.responseJSON.error);
                    }else{
                        app.alert();
                    }
                });
            })
        },
        logout: function ()
        {
            var customer = this;
            return customer.ApiRequest('Logout')
                .done(function (data, status)
                {
                    customer.clear();
                    customer.getUsableAdvantages(true,true);
                    app.getCart().remoteFetch();
                })
                .fail(function (data, status)
                {
                    app.alert();
                    customer.trigger('logoutFail', customer, data);
                });
        },
        getEmail: function ()
        {
            return this.get('email')
        },
        getFirstname: function ()
        {
            return this.get('firstname')
        },
        getLastname: function ()
        {
            return this.get('lastname')
        },
        getFullname: function ()
        {
            return this.getFirstname() + ' ' + this.getLastname();
        },
        isNewsletter: function ()
        {
            return this.get('mail_alert') == 1
        },
        isSms: function ()
        {
            return this.get('sms') == 1
        },
        // Neolane
        getNeolaneParam:function(key, defaultValue){
            var params = this.get('NeolaneParams'),
                value = defaultValue;
            if(params && params[key]){
                value = params[key];
            }else if(_.isUndefined(value) && this.isLogged()){
                app.error("NeolaneParam "+key+" is missing",this.id);
            }
            return value;
        },
        //
        likeHobby:function (slug) {
            return this.get(slug);
        },
        getHobbies:function(){
            // initialement ils viennent de Neolane | Comein
            var customer = this,
                hobbies = _(hobbiesSlugs).map(function(slug,index){
                    return {
                        slug:slug,
                        label:t(hobbiesNames[index],'Account'),
                        polygon:1+(index%3),
                        checked:customer.likeHobby(slug)
                        }
                    }
                );
            return _(hobbies);
        }

        //
    };

    var CustomerModel = ObjectModel.extend(LocalStorage).extend(CustomerModelPrototype);

    CustomerModel.STATUS_LIST = statusList;

    return CustomerModel;
});

